import React from 'react';
import { NavLink, Link } from 'react-router-dom';

function Browse() {

    return (
        <div className="search-container">
            <div className="tabs">
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/search">
                    Keyword
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/advanced-search">
                    Advanced
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/freeform-search">
                    Freeform
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/browse">
                    Browse
                </NavLink>
            </div>
            <h2>Browse</h2>
            <p>
                Browse all documents by the available facets, or alphanumerically by author or title.<br />
                <Link 
                    to={`/searchresults?keyword=brown&browse=true&smode=keyword&sort=date`} 
                >
                    Chronological Order
                </Link>{" "}
                |{" "}
                <Link 
                    to={`/searchresults?keyword=brown&browse=true&smode=keyword&sort=title`} 
                >
                    Title
                </Link>
            </p>
        </div>
    );
}

export default Browse;
